<template>
  <div id="container">
    <div class="backstep" @click="mailReturn">
      <i class="fas fa-long-arrow-alt-left"></i>
    </div>
    <h2>{{trad.pageName.titleLastname}}</h2>
    <input class="nameInput" type="text" required v-model="name" />
    <br />
    <h2>{{trad.pageName.titleFirstname}}</h2>
    <input class="nameInput" type="text" required v-model="firstname" />
    <br />
    <button @click="nameChecked">{{trad.pageName.button}}</button>
    <br />
    <img :src="help[randPic]" alt="Help-pic" />
    <div class="help-container">
      <div class="talk-bubble tri-right round btm-left">
        <div class="talktext">
          <p>{{trad.pageName.help}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "WelcomeNameCheck",
  data() {
    return {
      name: "",
      firstname: "",
      checked: false,
      trad: this.langTxt,
      help: ["help0.png", "help1.png", "help2.png", "help3.png", "help4.png"],
    };
  },
  props: ["demoProgression", "randPic","langTxt"],
  created: function() {
    window.scrollTo(0, document.body.scrollHeight);
    
    if (localStorage["name"] && localStorage["firstname"]) {
      this.name = localStorage["name"];
      this.firstname = localStorage["firstname"];
    } else {
      return false;
    }
  },
  methods: {
    nameChecked(e) {
      e.preventDefault();

      this.checked = true;

      this.demoProgression[0].name = this.name;
      this.demoProgression[0].firstname = this.firstname;
      this.demoProgression[0].completedName = this.checked;

      // Progression bar
      this.$emit("name-checked", this.demoProgression);

      // Stock in local browser
      localStorage.setItem("name", this.name);
      localStorage.setItem("firstname", this.firstname);
    },
    mailReturn() {
      if (this.demoProgression[0].demoStart) {
        this.demoProgression[0].demoStart = true;
        this.demoProgression[0].completedMail = false;
        this.demoProgression[0].completedName = false;
        this.demoProgression[0].completedPhone = false;
        this.demoProgression[0].sendClicked = false;
        this.demoProgression[0].preview = false;
      }
    },
  },
};
</script>

<style scoped>
#container {
  padding: 50px;
  padding-top: 35px;
  box-shadow: 10px 10px 20px 0px rgba(133, 133, 133, 0.55);
  margin: auto;
  width: fit-content;
  height: 580px;
  margin-top: 15px;
  border-radius: 10px;
  position: relative;
}
.nameInput {
  border-radius: 10px;
  border: none;
  width: 350px;
  height: 40px;
  box-shadow: #e6e6e6 4px 4px 8px;
  background-color: rgb(250, 250, 250);
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: rgb(59, 59, 59);
}
button {
  padding: 8px;
  background-color: #3F608E;
  color: white;
  font-size: 20px;
  font-weight: bold;
  border-radius: 10px;
  margin-top: 35px;
  cursor: pointer;
  border: none;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
button:hover {
  transition-duration: 0.8s;
  background: #7C9048;
}
h2 {
  margin: 25px;
  margin-top: 25px;
}

/* Start Help User */

.help-container {
  position: absolute;
  width: fit-content;
  height: fit-content;
  bottom: 95px;
  left: 90px;
}
img {
  width: 125px;
  position: absolute;
  left: -5px;
  bottom: -15px;
}
.talk-bubble {
  display: inline-block;
  position: relative;
  width: 300px;
  height: auto;
  background-color: #f9f9db;
}
.border {
  border: 8px solid #666;
}
.round {
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
}
.tri-right.border.btm-left:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -8px;
  right: auto;
  top: auto;
  bottom: -40px;
  border: 32px solid;
  border-color: transparent transparent transparent #666;
}
.tri-right.btm-left:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: 0px;
  right: auto;
  top: auto;
  bottom: -20px;
  border: 22px solid;
  border-color: transparent transparent transparent #f9f9db;
}
.talktext {
  padding: 1em;
  text-align: left;
  line-height: 1.5em;
}
.talktext p {
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  font-weight: 500;
}

/* End Help User */

@media screen and (max-width: 800px) {
  #container {
    width: 100%;
    padding: 40px;
  }
  .nameInput {
    width: 90%;
  }
  .talk-bubble {
    width: 225px;
  }
}


</style>
